module.exports = __webpack_public_path__ + "img/logo_5.d08e9e32.svg";